import "./App.css";

import { ThemeProvider, createTheme } from "@mui/material/styles";

import CheckboxCheckedIcon from "./assets/Icons/CheckboxCheckedIcon";
import CheckboxUncheckedIcon from "./assets/Icons/CheckboxUncheckedIcon";
import PropTypes from "prop-types";

function Theme(props) {
  const { children } = props;

  // const { data } = useQuery({
  //   queryKey: ["welcome"],
  // });

  const theme = createTheme({
    palette: {
      primary: {
        main: "#ffc72c", //TODO Fix for skin
        contrastText: "#12284a", //TODO Fix for skin
      },
      secondary: {
        main: "#12284a", //TODO Fix for skin
      },
      neutral: {
        main: "#efede7", //TODO Fix for skin
      },
      error: {
        main: "#b0001f", //TODO Fix for skin
      },
    },
    typography: {
      MuiCssBaseline: {
        styleOverrides: `@font-face {
          font-family: 'Geist';
          font-style: normal;
          font-weight: 400;
        }`,
      },
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            backgroundColor: "#EFEDE7",
            borderColor: "#C2C1BF",
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {},
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginLeft: "0px",
            fontWeight: 700,
            fontSize: "12px",
          },
        },
      },
      MuiCheckbox: {
        defaultProps: {
          icon: <CheckboxUncheckedIcon />,
          checkedIcon: <CheckboxCheckedIcon />,
        },
      },
      MuiModal: {
        styleOverrides: {
          root: {
            marginLeft: "1rem",
            marginRight: "1rem",
            "&:focus": {
              outline: "none",
            },
          },
        },
      },
      MuiBox: {
        styleOverrides: {
          root: {
            "&:focus-visible": {
              outline: "none",
            },
          },
        },
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

Theme.propTypes = {
  children: PropTypes.node,
};

export default Theme;
